import { type RefObject } from "react";

import type { ExternalShippingCarrierAddress } from "@jti/commerce-types";
import { type ScriptStatuses } from "@jti/ui";

export type CustomShippingOptionErrorCodes =
  "SCRIPT_LOADING_ERROR" | "INVALID_STORE_ADDRESS" | "WIDGET_CRASH" | "WIDGET_INITIALIZATION_FAIL";

export type CustomShippingOptionError = {
  message: string;
  code?: CustomShippingOptionErrorCodes | string;
};

export type CustomShippingOptionErrorCallback = (error: CustomShippingOptionError | undefined) => void;

export type CustomShippingOptionWidgetVariantsCommonProps = {
  selectedAddress?: ExternalShippingCarrierAddress | null;
  widgetUrl: string;
  webComponentTagName: string;
  webComponentRef: RefObject<HTMLDivElement | null>;
  scriptStatus: ScriptStatuses;
  widgetError?: CustomShippingOptionError | null;
  children?: React.ReactNode;
  addressValidationError?: string;
};
